import React from 'react';
import DropModal from 'components/shared/DropModal/DropModal';
import FilterTable from '../FilterTable/FilterTable';
import '../../FiltersBar.css';
import { DEVICES_PAGE_TAB } from 'common/utils/constants';

const FiltersBarFiltersContainer = (props) => {
  let filterKeys;
  if (props.activeTab === DEVICES_PAGE_TAB.all) {
    filterKeys = ['Connection Status', 'Admin State', 'Operational State', 'Device Type', 'Provisioned On', 'Alarms'];
  } else {
    filterKeys = ['Connection Status', 'Admin State', 'Operational State', 'Provisioned On', 'Alarms'];
  }

  return (
    <div className="FiltersBar_FiltersContainer">
      {filterKeys.map((key) => {
        return (
          <div className="FilterBars_Filter" key={key}>
            <DropModal
              title={key}
              name={key}
              isFilterBox={true}
              activeFilterItems={props.getActiveFilterItems(key)}
              onClose={props.handleActiveFilterOnClose}
            >
              {<FilterTable filterKey={key} fetching={props.fetching} handleDateSubmit={props.handleDateSubmit} />}
            </DropModal>
          </div>
        );
      })}
    </div>
  );
};

export default FiltersBarFiltersContainer;
